// DataTables core and plugins are imported in application.js
// This file only contains the initialization function

export function initAdminDashboardDataTables() {
  const root = document.getElementById("admin-dashboard");
  if (!root) return;

  const $ = window.jQuery || window.$;
  if (!$ || !$.fn || !$.fn.DataTable) return;

  const initTable = (selector) => {
    const $table = $(selector);
    if ($table.length === 0) return;
    if ($.fn.dataTable.isDataTable($table)) return;

    $table.DataTable({
      pageLength: 10,
      ordering: true,
      searching: true,
      responsive: true,
      language: {
        search: "Filter:",
        lengthMenu: "Show _MENU_ rows",
        info: "Showing _START_ to _END_ of _TOTAL_",
        infoEmpty: "No rows",
        zeroRecords: "No matching rows",
      },
    });
  };

  initTable("#downloads-table");
  initTable("#power-users-table");
}

